<div data-testid="inbound-notice-view-page" class="inbound-form-wrapper-container">
  <!-- Sticky Header -->
  <div class="sticky-header">
    <div class="flex justify-between items-center mb-5">
      <h2 class="text-2xl font-semibold text-gray-800">
        {{ "inbound.notice.title.view" | translate }}
      </h2>
      <div class="flex gap-3">
        <app-button
          [testId]="'inbound-notice-view-back-btn'"
          [label]="'common.actions.back' | translate"
          (emitOnClick)="onBack()"
          [outlined]="true"
          type="secondary"
        ></app-button>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="inbound-form-wrapper-content">
    <div class="p-2">
      @if (loading()) {
        <div class="flex justify-center items-center py-8">
          <p-progressSpinner data-testid="inbound-notice-view-loading"></p-progressSpinner>
        </div>
      } @else {
        <!-- Basic Information Section -->
        <section class="form-section pl-6 mb-4 notice-basic-section">
          <div class="flex items-center px-4">
            <h2 class="section-title text-lg font-semibold mr-4">
              {{ "inbound.sections.basic_information" | translate }}
            </h2>
          </div>
          <div class="grid gap-2 pl-8 pr-4 py-2 grid-cols-4">
            <!-- Row 1: code, innerOrderNo, creationDate, status -->
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.notice_code" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ getFieldValue("code") || "-" }}
              </p>
            </div>
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.table.columns.inner_order_number" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ getFieldValue("innerOrderNo") || "-" }}
              </p>
            </div>
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.creation_date" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ formatDate(getFieldValue("creationDate")) || "-" }}
              </p>
            </div>
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.status" | translate }}
              </label>
              <div class="mt-1">
                <p-tag
                  data-testid="inbound-notice-view-status-tag"
                  [value]="getStatusLabel(getFieldValue('status'))"
                  [severity]="getStatusSeverity(getFieldValue('status'))"
                  styleClass="status-tag"
                  [ngStyle]="getStatusStyle(getFieldValue('status'))"
                  pTooltip="{{ getStatusLabel(getFieldValue('status')) }}"
                  tooltipPosition="top"
                  tooltipStyleClass="custom-tooltip"
                  [showDelay]="300"
                  [hideDelay]="0"
                />
              </div>
            </div>
          </div>
          <div class="grid gap-2 pl-8 pr-4 py-2 grid-cols-4">
            <!-- Row 2: warehouseName, realNoticeCode, deliveryDate, remarks -->
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.warehouse_name" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ getFieldValue("warehouseName") || "-" }}
              </p>
            </div>
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.real_notice_code" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ getFieldValue("realNoticeCode") || "-" }}
              </p>
            </div>
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.delivery_date" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{
                  formatDateOnly(getFieldValue("expectedArrivalDate")) || "-"
                }}
              </p>
            </div>
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.remarks" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ getFieldValue("remarks") || "-" }}
              </p>
            </div>
          </div>
          <div class="grid gap-2 pl-8 pr-4 py-2 grid-cols-4">
            <!-- Row 3: trackingNumber, carrierName -->
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.tracking_number" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ getFieldValue("trackingNumber") || "-" }}
              </p>
            </div>
            <div class="form-field">
              <label class="form-label text-sm">
                {{ "inbound.notice.fields.carrier_name" | translate }}
              </label>
              <p class="text-sm text-gray-800 mt-1">
                {{ getFieldValue("carrierName") || "-" }}
              </p>
            </div>
          </div>
        </section>

        <!-- Item Details Section -->
        <section class="form-section mb-4">
          <div class="flex items-center mb-2 px-4">
            <h2 class="section-title text-lg font-semibold mr-4">
              {{ "inbound.sections.item_details" | translate }}
            </h2>
          </div>
          <div class="pl-6 ml-4 py-1">
            <app-data-table
              data-testid="inbound-notice-view-items-table"
              [columns]="itemTableColumns"
              [dataSource]="formattedItemDetails()"
              [loading]="loading()"
              [hasCheckColumn]="false"
              [totalRecords]="inboundDetailItemsForWrapper().length"
              [first]="0"
              [rows]="20"
            ></app-data-table>
          </div>
        </section>
      }
    </div>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="inbound-notice-view-toast"></p-toast>
